/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import RankingQueryResultMcStats from './RankingQueryResultMcStats';

/**
 * The RankingOutputRankingMcStats model module.
 * @module model/RankingOutputRankingMcStats
 * @version 1.0
 */
class RankingOutputRankingMcStats {
    /**
     * Constructs a new <code>RankingOutputRankingMcStats</code>.
     * @alias module:model/RankingOutputRankingMcStats
     */
    constructor() { 
        
        RankingOutputRankingMcStats.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RankingOutputRankingMcStats</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RankingOutputRankingMcStats} obj Optional instance to populate.
     * @return {module:model/RankingOutputRankingMcStats} The populated <code>RankingOutputRankingMcStats</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RankingOutputRankingMcStats();

            if (data.hasOwnProperty('mcStats')) {
                obj['mcStats'] = ApiClient.convertToType(data['mcStats'], [RankingQueryResultMcStats]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/RankingQueryResultMcStats>} mcStats
 */
RankingOutputRankingMcStats.prototype['mcStats'] = undefined;






export default RankingOutputRankingMcStats;

